import styled from '@emotion/styled';

import { greyish } from '~/styles';

import { AuthorNameDark, CardContentTitle, LevelTitle } from '../elements';

export const AuthorText = styled(AuthorNameDark)`
  font-size: 10px;
`;

export const Duration = styled.span`
  color: ${greyish};
  font-size: 10px;
  line-height: 16px;
  font-weight: 200;
  padding-left: 4px;
`;

export const StyleText = styled(LevelTitle)`
  font-size: 11px;
`;

export const Title = styled(CardContentTitle)`
  line-height: 18px;
  padding-top: 5px;
`;
